<template>
  <div ref="vantaRef" class="vanta-globe-scroll" />
</template>

<script setup lang="ts">
const vantaRef = ref<HTMLElement | null>(null)
let vantaEffect: any = null
let rafId: number | null = null

const { isDark } = useTheme()

const createEffect = () => {
  if (process.client && vantaRef.value) {
    if (vantaEffect) {
      vantaEffect.destroy()
      vantaEffect = null
    }

    try {
      const THREE = window.THREE
      const VANTA = window.VANTA

      if (!THREE || !VANTA?.GLOBE) {
        console.error('VantaGlobeScroll: Three.js or Vanta.GLOBE not loaded from CDN')
        return
      }

      vantaEffect = VANTA.GLOBE({
        el: vantaRef.value,
        THREE: THREE,
        mouseControls: true,
        touchControls: true,
        gyroControls: true,
        minHeight: 200.00,
        minWidth: 200.00,
        scale: 1.00,
        scaleMobile: 1.00,
        color: isDark.value ? 0xffbb3f : 0xff7800,
        backgroundColor: isDark.value ? 0x060518 : 0xffffff,
        size: 0.95,
        showDots: true,
      })
    } catch (error) {
      console.error('VantaGlobeScroll initialization failed:', error)
    }
  }
}

const handleScroll = () => {
  if (rafId !== null) return
  rafId = requestAnimationFrame(() => {
    const scrollY = window.scrollY
    const heroHeight = window.innerHeight
    const fadeEnd = heroHeight * 0.7
    const opacity = Math.max(0, 1 - (scrollY / fadeEnd))

    if (vantaRef.value) {
      vantaRef.value.style.opacity = String(opacity)
    }
    rafId = null
  })
}

onMounted(() => {
  createEffect()
  if (process.client) {
    window.addEventListener('scroll', handleScroll, { passive: true })
  }
})

watch(isDark, () => {
  if (process.client) {
    nextTick(() => {
      createEffect()
    })
  }
})

onBeforeUnmount(() => {
  if (rafId !== null) cancelAnimationFrame(rafId)
  if (vantaEffect) vantaEffect.destroy()
  if (process.client) {
    window.removeEventListener('scroll', handleScroll)
  }
})
</script>

<style scoped>
.vanta-globe-scroll {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 0;
  margin: 0;
  padding: 0;
  background-color: var(--bg-primary);
  transition: background-color 0.3s ease;
  will-change: opacity;
}

.vanta-globe-scroll :deep(canvas) {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
}
</style>
